import { PageLink, PageTitle } from '_metronic/layout/core';
import { FC } from 'react';
import { useLocation } from 'react-router-dom';
import ViewPD from './components/View';


const PercepDeducPage: FC = () => {
  let location = useLocation();
  const breadCrumbs: Array<PageLink> = [
    {
      title: 'Configuración',
      path: location.pathname,
      isSeparator: false,
      isActive: true,
      
    },
    {
      title: 'Percepciones & Deducciones',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ];

  return (
    <>
      <PageTitle breadcrumbs={breadCrumbs}>Percepciones & Deducciones</PageTitle>
      <ViewPD/>
    </>
  );
};

export {PercepDeducPage}